import { local } from './store.js'

import DE from '../../app/public/translations/locale_DE.json'
import EN from '../../app/public/translations/locale_EN.json'

export function translate(key) {
    let keyMap = 'DE';
    if (local === 'EN') {
        keyMap = 'EN';
    }
    const value = keyMap === 'DE' ? DE[key] : EN[key];

    if (value === undefined) {
        return key;
    }
    return value;
}